import { getThemeProductDetailSupport } from "../../Core/Support/GetThemeProductDetailSupport";
import { getThemeBlogDetailSupport } from "../../Core/Support/GetThemeBlogDetailSupport";

/***
 * 取得各主題產品資訊、文章推薦
 ***/
export function SheetTourProductService() {

  //取得各主題產品列表
  let _getThemeTourDetail = async function (spread_id, flagship_sheets_list) {
    let product_list = await getThemeProductDetailSupport(spread_id, flagship_sheets_list);

    return product_list;
  };

  // 取得各主題推薦文章
  let _getThemeBlogDetail = async function (spread_id, flagship_sheets_list) {
    let blog_list = await getThemeBlogDetailSupport(spread_id,flagship_sheets_list);

    return blog_list;
  };

  return {
    getThemeBlogDetail: _getThemeBlogDetail,
    getThemeTourDetail: _getThemeTourDetail,
  };
}
